var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { FormattedMessage, FormattedTime, injectIntl } from 'react-intl';
import { ApplicationContext } from '../../../../ApplicationContext';
import * as Atlas from 'azure-maps-control';
import { ControlPosition } from 'azure-maps-control';
import Settings from '../../../../data/Settings';
import searchByAddress from '../../../../requests/azuremaps/searchByAddress';
import reverseGeoLookup from '../../../../requests/azuremaps/reverseGeoLookup';
import { parseFloatUniversal } from "../../../../utils/numberUtils";
/**
 *
 */
var LocationPicker = /** @class */ (function (_super) {
    __extends(LocationPicker, _super);
    /**
     *
     */
    function LocationPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            address: props.address
        };
        _this.onAddressChange = _this.onAddressChange.bind(_this);
        _this.searchAddress = _this.searchAddress.bind(_this);
        _this.searchAddressDebounce = _.debounce(_this.searchAddress, 500);
        _this.onMapClick = _this.onMapClick.bind(_this);
        _this.onMarkerDragEnd = _this.onMarkerDragEnd.bind(_this);
        _this.onMapReady = _this.onMapReady.bind(_this);
        return _this;
    }
    /**
     *
     */
    LocationPicker.prototype.componentDidMount = function () {
        this.initializeMap();
        this.setState({
            newAddress: ""
        });
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    LocationPicker.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a = this.props, latitude = _a.latitude, longitude = _a.longitude;
        if (prevProps.latitude !== latitude || prevProps.longitude !== longitude) {
            var _b = this.state, marker = _b.marker, map = _b.map;
            if (marker) {
                marker.setOptions({ position: [longitude, latitude], visible: true });
                // Set initial zoom level
                if (latitude !== 0 || longitude !== 0) {
                    map.setCamera({
                        zoom: 14,
                        center: [longitude, latitude]
                    });
                    //  Reset
                }
                else {
                    marker.setOptions({ position: [0, 0], visible: false });
                    map.setCamera({
                        zoom: 1,
                        center: [0, 0]
                    });
                }
            }
        }
    };
    /**
     *
     * @returns {*}
     */
    LocationPicker.prototype.render = function () {
        var _this = this;
        var _a = this.state, address = _a.address, newAddress = _a.newAddress;
        var intl = this.props.intl;
        var addressDateString = this.props.addressDateString;
        var addressDate = new Date(addressDateString);
        var classes = classNames({
            'location-picker': true
        });
        return (React.createElement("div", { className: classes },
            React.createElement("input", { className: "form-control", type: "text", name: "address", id: "address", value: newAddress, placeholder: intl.formatMessage({ id: 'manual.asset.create.overlay.no.update' }), onChange: function (event) {
                    _this.setState({ newAddress: event.target.value });
                    _this.searchAddressDebounce();
                }, onBlur: this.searchAddress, onKeyDown: function (event) {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        event.target.blur();
                    }
                } }),
            React.createElement("span", { className: "small text-muted d-block" }, this.props.showLastKnownLocation ?
                React.createElement(React.Fragment, null, address && addressDate.getTime() > 0 ?
                    React.createElement(React.Fragment, null,
                        intl.formatMessage({ id: 'manual.asset.create.overlay.field.last.known.location' }, { lastAddress: address }),
                        React.createElement(FormattedTime, { value: addressDate })) : React.createElement(FormattedMessage, { id: "location.last.unknown" })) : null),
            React.createElement("div", { className: "location-picker__map-container mt-2" },
                React.createElement("div", { id: "azure-map-location" }))));
    };
    /**
     *
     * @param event
     */
    LocationPicker.prototype.onMapReady = function (event) {
    };
    /**
     *
     */
    LocationPicker.prototype.onAddressChange = function (event) {
        var _this = this;
        this.setState({ newAddress: event.currentTarget.value }, function () {
            _this.searchAddress();
        });
    };
    /**
     *
     */
    LocationPicker.prototype.searchAddress = function () {
        var _this = this;
        var _a = this.state, newAddress = _a.newAddress, marker = _a.marker, map = _a.map;
        if (newAddress.indexOf('latitude:') >= 0 || newAddress.indexOf('longitude:') >= 0) {
            var splitAddr = newAddress.split(' ');
            var lat = parseFloatUniversal(splitAddr[1]);
            var lon = parseFloatUniversal(splitAddr[3]);
            this.updateLocation(lat, lon);
            // reverse geo
            reverseGeoLookup(lat, lon).then(function (response) {
                var locationPlace = response.addresses[0].address.freeformAddress;
                _this.setState({ newAddress: locationPlace });
            }).catch(function (err) {
                console.log('reverse geo lookup error', err);
            });
            return;
        }
        // Empty field
        if (!newAddress || newAddress.trim() === '') {
            this.updateLocation(0, 0);
            if (marker) {
                map.setCamera({
                    zoom: 1,
                    center: [0, 0]
                });
            }
            return;
        }
        // Search address
        searchByAddress(newAddress).then(function (response) {
            var map = _this.state.map;
            if (response.results && response.results.length > 0) {
                var locationData = response.results[0];
                _this.updateLocation(locationData.position.lat, locationData.position.lon);
                var cameraBounds = Atlas.data.BoundingBox.fromPositions([
                    new Atlas.data.Position(locationData.viewport.topLeftPoint.lon, locationData.viewport.topLeftPoint.lat),
                    new Atlas.data.Position(locationData.viewport.btmRightPoint.lon, locationData.viewport.btmRightPoint.lat)
                ]);
                map.setCamera({ bounds: cameraBounds, padding: { top: 32, left: 32, bottom: 32, right: 32 } });
            }
        }).catch(function (err) {
            console.log('onAddressChange error', err);
        });
    };
    /**
     *
     * @param event
     */
    LocationPicker.prototype.onMapClick = function (event) {
        var position = event.position;
        this.setState({ newAddress: 'latitude: ' + (Math.round(position[1] * 1000000) / 1000000) + ' longitude: ' + (Math.round(position[0] * 1000000) / 1000000) });
        this.searchAddress();
    };
    /**
     *
     * @param event
     */
    LocationPicker.prototype.onMarkerDragEnd = function (event) {
        var position = event.target.options.position;
        this.updateLocation(position[1], position[0]);
        this.setState({ newAddress: 'latitude: ' + (Math.round(position[1] * 1000000) / 1000000) + ' longitude: ' + (Math.round(position[0] * 1000000) / 1000000) });
    };
    /**
     *
     */
    LocationPicker.prototype.initializeMap = function () {
        // @ts-ignore
        var map = new Atlas.Map('azure-map-location', Settings.AZURE_MAPS_OPTIONS);
        var _a = this.props, latitude = _a.latitude, longitude = _a.longitude;
        //Create a HTML marker and add it to the map.
        var marker = new Atlas.HtmlMarker({
            position: [longitude, latitude],
            draggable: true
        });
        if (longitude === 0 && latitude === 0) {
            marker.setOptions({ visible: false });
        }
        map.markers.add(marker);
        map.controls.add(new Atlas.control.ZoomControl(), {
            position: ControlPosition.BottomRight
        });
        map.events.add('ready', this.onMapReady);
        map.events.add('click', this.onMapClick);
        map.events.add('dragend', marker, this.onMarkerDragEnd);
        this.setState({ map: map, marker: marker });
    };
    /**
     *
     * @param lat
     * @param lon
     */
    LocationPicker.prototype.updateLocation = function (lat, lon) {
        var onPositionChange = this.props.onPositionChange;
        if (onPositionChange) {
            onPositionChange(lat, lon);
        }
        var marker = this.state.marker;
        if (marker) {
            marker.setOptions({ position: [lon, lat], visible: !(lat === 0 && lon === 0) });
        }
    };
    LocationPicker.defaultProps = {
        address: '',
        latitude: 0,
        longitude: 0,
        showLastKnownLocation: true,
    };
    return LocationPicker;
}(React.Component));
LocationPicker.contextType = ApplicationContext;
export default injectIntl(LocationPicker);
